import styled from 'styled-components';
import { Dropdown } from 'primereact/dropdown';

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media (max-width: 768px) { gap: 14px; }
`;

export const TabsContainer = styled.div`
    display: flex;
    gap: 8px;
    padding: 4px;
    background: #F6F6F6;
    border-radius: 8px;
    width: fit-content;
    @media (max-width: 768px) { width: 100%; }
`;

export const Tab = styled.button<{ $active: boolean }>`
    padding: 8px 20px;
    border: none;
    border-radius: 6px;
    background: ${({ $active }) => ($active ? '#FFFFFF' : 'transparent')};
    color: ${({ $active }) => ($active ? '#000000' : '#7B7B7B')};
    font-family: SF Pro Display, sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover { color: #000000; }
    @media (max-width: 768px) {
        flex: 1;
        padding: 6px 16px;
        font-size: 12px;
    }
`;

export const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    @media (max-width: 768px) { gap: 6px; }
`;

export const Label = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: SF Pro Display, sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    color: #000000;
    cursor: default;
    user-select: none;
    @media (max-width: 768px) { font-size: 12px; }
`;

export const InfoIcon = styled.span`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    transition: opacity 0.2s ease;

    svg {
        width: 16px;
        height: 12px;
        transition: opacity 0.2s ease;
    }

    /* Desktop hover effect */
    @media (min-width: 769px) {
        &:hover svg {
            opacity: 0.7;
        }
    }

    @media (max-width: 768px) {
        svg {
            width: 14px;
            height: 14px;
        }
    }
`;

export const Input = styled.input`
    height: 42px;
    padding: 0 16px;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
    font-family: SF Pro Display, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 15px;
    color: #000000;
    background: #FFFFFF;
    transition: all 0.2s ease;
    &::placeholder { color: #A0A0A0; }
    &:focus {
        outline: none;
        border-color: #000000;
    }
    &:not(:placeholder-shown) { border-color: #000000; }
    @media (max-width: 768px) {
        padding: 0 14px;
        font-size: 12px;
    }
`;

export const StyledDropdown = styled(Dropdown)`
    height: 42px;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
    background: #FFFFFF;
    transition: all 0.2s ease;
    .p-dropdown-label {
        font-family: SF Pro Display, sans-serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 15px;
        padding: 0 16px;
        color: #000000;
        display: flex;
        align-items: center;
        &.p-placeholder { color: #A0A0A0; }
    }
    .p-dropdown-trigger {
        width: max-content !important;
        margin-right: 12px;
    }
    &:hover { border-color: #000000; }
    &.p-focus {
        box-shadow: none;
        border-color: #000000 !important;
    }
    &.p-inputwrapper-filled { border-color: #000000; }
    @media (max-width: 768px) {
        .p-dropdown-label {
            font-size: 12px;
            padding: 0 14px;
        }
    }
`;

export const TwoColumnRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 14px;
    }
`;

export const ButtonWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    button {
        width: 210px;
        height: 46px;
        border-radius: 10px;
        font-family: Outfit, sans-serif;
        font-weight: 400;
        font-size: 16px;
    }
    @media (max-width: 768px) {
        justify-content: center;
        button { width: 100%; }
    }
`;